import { transactionTypes as constantsTransactionTypes } from '@/returns/constants'

export const actionTypeValues = {
  none: 'none',
  block: 'block',
  bonus: 'bonus',
  onHold: 'on_hold',
}

export const actionTypeOptions = [
  {
    value: actionTypeValues.none,
    label: 'Sin acción',
  },
  {
    value: actionTypeValues.bonus,
    label: 'Bonificación',
  },
  {
    value: actionTypeValues.block,
    label: 'Bloqueo',
  },
  {
    value: actionTypeValues.onHold,
    label: 'En espera',
  },
]

export const transactionTypes = [
  {
    value: constantsTransactionTypes.refund,
    label: 'Devolución',
  },
  {
    value: constantsTransactionTypes.exchange,
    label: 'Cambio',
  },
]

export const bonusOptions = [
  {
    label: 'Devolución gratuita',
    value: 'disable_return_fees_refund',
  },
  {
    label: 'Cambio gratuito',
    value: 'disable_return_fees_exchange',
  },
  {
    label: 'Reembolsar gastos de envío del pedido original',
    value: 'refund_shipping_amount',
  },
]
